<template>
	<v-col
		cols="12" sm="12" md="3" lg="3" xl="3"
		class="d-flex align-start flex-column mt-5"
	>
		<div
			class="text-center mx-auto"
			data-aos="fade-up"
		>
			<div>
				<v-img
					:src="image"
					contain
					height="120px"
				></v-img>
			</div>
		<div
				class="py-3 primary--text font-weight-bold"
				:class="MIXIN_SETUP_UI.title"
			>
				{{ title }}
			</div>
		</div>
		<base-step-number v-if="MIXIN_SETUP_UI.show" :line="line" :number="number" class="mx-auto"></base-step-number>
	</v-col>
</template>

<script>
	export default {
		name: "StepColum",
		props: {
			image: { type: String, default: '' },
			title: { type: String, default: '' },
			number: { type: Number },
			line: { type: Boolean, default: false }
		}
	}
</script>

<style lang="scss" scoped>

</style>